import React from "react";
import { Navigate } from "react-router-dom";

export default [
	{
		path: "/",
		element: React.lazy(() => import("@page/LeadListPage")),
	},
	{
		path: "/ugyleteim",
		element: () => <Navigate to="/" />,
	},
	{
		path: "/ugyleteim/:id",
		element: React.lazy(() => import("@page/LeadPage")),
	},
	{
		path: "/ugyleteim/:id/:bankCaseId",
		element: React.lazy(() => import("@page/LeadPage")),
	},
	// Intentionally ungated (base routes, not ANALYSIS_ROUTES): users must be able to revoke a
	// previously granted Aggreg8 consent even when the account analysis feature is disabled for them.
	{
		path: "/szamla-elemzeseim/aggreg8",
		element: React.lazy(() => import("@page/analysis/AnalysisAuthorizationsPage")),
	},
	{
		path: "/bejelentkezes/",
		element: () => <Navigate to="/" />,
	},
	{
		path: "/regisztracio/",
		element: React.lazy(() => import("@page/AlreadyLoggedInPage")),
	},
	{
		path: "/elfelejtett-jelszo/",
		element: React.lazy(() => import("@page/AlreadyLoggedInPage")),
	},
];

export const ANALYSIS_ROUTES = [
	{
		path: "/szamla-elemzeseim",
		element: React.lazy(() => import("@page/analysis/AnalysisListPage")),
	},
	{
		path: "/szamla-elemzeseim/uj",
		element: React.lazy(() => import("@page/analysis/NewAnalysisPage")),
	},
	{
		path: "/szamla-elemzeseim/:bankCode",
		element: React.lazy(() => import("@page/analysis/AnalysisDetailPage")),
	},
];
